import { createSelector } from 'reselect';

import type { State } from '@wetransfer/transfer/store/types';

import { CurrentOrderState, Order, OrderErrorType } from './types';

const selectCurrentOrderSlice = (state: State): CurrentOrderState =>
  state.currentOrder;

export const selectCurrentOrder = createSelector(
  selectCurrentOrderSlice,
  (currentOrder: CurrentOrderState): Order | null => currentOrder.order
);

export const selectCurrentOrderError = createSelector(
  selectCurrentOrderSlice,
  (currentOrder: CurrentOrderState): OrderErrorType | null =>
    currentOrder.errorType
);
